module.exports = __webpack_public_path__ + "static/media/ic_camera_reverse_on.7efdc35f.svg";